/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { investmentNeedAllocationCategoryDtoSchema } from "./investmentNeedAllocationCategoryDtoSchema.ts";
import { investmentNeedInvestmentImpactDtoSchema } from "./investmentNeedInvestmentImpactDtoSchema.ts";
import { investmentNeedInvestmentRangeDtoSchema } from "./investmentNeedInvestmentRangeDtoSchema.ts";
import { z } from "zod/v4";

export const investmentNeedUseOfFundsDtoSchema = z.object({
  allocationLabel: z.optional(z.string()),
  get categories() {
    return z.array(investmentNeedAllocationCategoryDtoSchema).optional();
  },
  get investmentRange() {
    return z.array(investmentNeedInvestmentRangeDtoSchema).optional();
  },
  get investmentImpact() {
    return z.array(investmentNeedInvestmentImpactDtoSchema).optional();
  },
});
